import React from "react";
import ReactDOM from "react-dom";
import { Formik, Form, Field } from "formik";
import { ApiService } from "../../../services/ApiService";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// const EditHoliday = ({ toggle, modal,alert,categoryType,getRequest,data,deleteHoliday}) =>
//     modal
//         ? ReactDOM.createPortal(
//               <React.Fragment>
//                   <div
//                       className="reactmodal fades"
//                       id="createAssetModal"
//                       role="dialog"
//                       aria-labelledby="myModalLabel"
//                       aria-hidden="true"
//                   >
//                       <div className="modal-dialog modal-lg" role="document">
//                           <div className="modal-content conmodal high-1">
//                               <div className="modal-header">
//                                   <h4
//                                       className="modal-title w-100"
//                                       style={{ color: "#000" }}
//                                   >
//                                       Edit an Event
//                                   </h4>
//                                   <button
//                                       type="button"
//                                       className="close"
//                                       data-dismiss="modal"
//                                       aria-label="Close"
//                                       onClick={toggle}
//                                   >
//                                       <span aria-hidden="true">&times;</span>
//                                   </button>
//                               </div>
//                               <div className="modal-body">

//                                         <Formik
//                         initialValues={{ event_type:data.title,event_category:data.cat,event_start_date:data.start ,event_end_date:data.end,holiday_id:data.id}}
//                         onSubmit={(values) => {
//                             ApiService.post("update-holiday", values).then(res => {
//                                 if(res.data.type===false){
//                                     alert.error(res.data.msg)
//                                 }else if(res.data.type === true){
//                                 alert.success(res.data.msg)
//                             }
//                             getRequest()
//                             toggle()

//                             })
//                         }}
//                     >
//                         {({ isSubmitting,values,setFieldValue }) => (
//                             <Form>

//                                 <div className="form-group">

//                                                <label > Event Name<span className="text-danger"> * </span></label>
//                                                <Field
//                                                type="text" className="form-control"
//                                                 id="event_type" name="event_type"/>

//                                        </div>
// <div className="form-group">

//         <label > Category Type<span className="text-danger"> * </span></label>
//         <Field as="select" className="form-control" id="event_category" name="event_category">
//             <option   >--Select Leave type--</option>

//             {categoryType.map((cat, i) => (
//                     <option value={cat.id} key={i}>
//                     {cat.name}
//                     </option>
//                 ))}
//         </Field>

// </div>
// <label > Start Date <span className="text-danger"> * </span></label>

// <div className="form-group">
//         <DatePicker
//         selected={Date.parse(values.event_start_date)}
//         dateFormat="MMMM d, yyyy"
//         className="form-controls"
//         name="start_date"
//         minDate={new Date()}
//         onChange={date => setFieldValue('event_start_date', date)}
//         />
// </div>
// <label > End Date <span className="text-danger"> * </span></label>

// <div className="form-group">
//     <DatePicker
//         selected={Date.parse(values.event_end_date)}
//         dateFormat="MMMM d, yyyy"
//         className="form-controls"
//         name="end_date"
//         minDate={new Date()}
//         onChange={date => setFieldValue('event_end_date', date)}
//         />
// </div>

//                                           <div class="modal-footer">
//                         <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal"  onClick={toggle}>Cancel</button>
//                         <button type="button"
//                          onClick={async()=>{
//                              toggle()
//                             await deleteHoliday(data.id)
//                             }}
//                          class="btn btn-danger btn-sm" id="delete_calendar_event_btn">
//                             <span class="fa fa-trash"></span>  Delete
//                         </button>
//                         <button type="submit" class="btn btn-block nt-button-color-default"  id="submit_edit_calender_event_btn">
//                             Update
//                         </button>
//                     </div>

//                             </Form>
//                         )}
//                     </Formik>
//                               </div>
//                           </div>
//                       </div>
//                   </div>
//               </React.Fragment>,
//               document.body
//           )
//         : null;

// export default EditHoliday;

export default function EditHoliday({
  closeModal,
  alert,
  categoryType,
  getRequest,
  data,
  deleteHoliday,
}) {
  return (
    <React.Fragment>
      <h4 className="modal-title w-100" style={{ color: "#000" }}>
        Edit an Event
      </h4>
      <Formik
        initialValues={{
          event_type: data.title,
          event_category: data.cat,
          event_start_date: data.start,
          event_end_date: data.end,
          holiday_id: data.id,
        }}
        onSubmit={(values) => {
          ApiService.post(`holidays/update-holiday/${data.id}`, values).then(
            (res) => {
              if (res.data.type === false) {
                alert.error(res.data.msg);
              } else if (res.data.type === true) {
                alert.success(res.data.msg);
              }
              getRequest();
              closeModal();
            }
          );
        }}
      >
        {({ handleSubmit, values, isSubmitting, setFieldValue }) => (
          <Form>
            <div className="form-group">
              <label>
                {" "}
                Event Name<span className="text-danger"> * </span>
              </label>
              <Field
                type="text"
                className="form-control"
                id="event_type"
                name="event_type"
                required
              />
            </div>
            <div className="form-group">
              <label>
                {" "}
                Category Type<span className="text-danger"> * </span>
              </label>
              <Field
                as="select"
                className="form-control"
                id="event_category"
                name="event_category"
              >
                <option>--Select Leave type--</option>

                {categoryType.map((cat, i) => (
                  <option value={cat.id} key={i}>
                    {cat.name}
                  </option>
                ))}
              </Field>
            </div>
            <label>
              {" "}
              Start Date <span className="text-danger"> * </span>
            </label>

            <div className="form-group">
              <DatePicker
                selected={Date.parse(values.event_start_date)}
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="start_date"
                minDate={new Date()}
                onChange={(date) => setFieldValue("event_start_date", date)}
              />
            </div>
            <label>
              {" "}
              End Date <span className="text-danger"> * </span>
            </label>

            <div className="form-group">
              <DatePicker
                selected={Date.parse(values.event_end_date)}
                dateFormat="MMMM d, yyyy"
                className="form-control"
                name="end_date"
                minDate={new Date()}
                onChange={(date) => setFieldValue("event_end_date", date)}
              />
            </div>
            <div className="form-group row">
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-2">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={async () => {
                    closeModal();
                    await deleteHoliday(data.id);
                  }}
                >
                  Delete
                </button>
              </div>
              <div className="col-md-8">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Update{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/calendar/edit_holiday.js